export const environment = {
  production: true,
  userStorage: 'userInfo',
  manualLogin: 'manualLogin',
  jwt: 'JwtPro',
  // procertFront: 'http://localhost:4200',
  // procertServices: 'https://localhost:44314',
  procertFront: 'https://emazweprocertpstg01.z6.web.core.windows.net',
  procertServices: 'https://procert-api.prosegur.net',
  homeServices: '',
  protocol: 'http',
  limitRowsExcel: 10000,
  version: "3.4.4",
};
